import React from 'react';
import { Check, X } from 'lucide-react';
import { Button } from './ui/Button';
import { trackAddToCart } from '../utils/metaPixel';
export function ForWhoSection() {
  return <section className="py-20 bg-white" data-id="element-89">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8" data-id="element-90">
        <div className="max-w-5xl mx-auto" data-id="element-91">
          <div className="text-center mb-12" data-id="element-92">
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900" data-id="element-93">
              Este reto es para vos si…
            </h2>
          </div>

          <div className="grid md:grid-cols-2 gap-8 mb-12" data-id="element-94">
            {/* YES Column */}
            <div className="bg-emerald-50 rounded-2xl p-8 border border-emerald-100" data-id="element-95">
              <div className="flex items-center gap-3 mb-6" data-id="element-96">
                <div className="bg-emerald-500 text-white p-2 rounded-full" data-id="element-97">
                  <Check className="w-6 h-6" data-id="element-98" />
                </div>
                <h3 className="text-xl font-bold text-emerald-900" data-id="element-99">
                  SÍ es para vos
                </h3>
              </div>
              <ul className="space-y-4" data-id="element-100">
                {['Querés bajar inflamación sin dietas extremas', 'Querés comer rico sin culpa ni ansiedad', 'No tenés tiempo para planes complicados', 'Buscás algo realista, simple y sostenible'].map((item, idx) => <li key={idx} className="flex items-start gap-3" data-id="element-101">
                    <Check className="w-5 h-5 text-emerald-600 mt-0.5 flex-shrink-0" data-id="element-102" />
                    <span className="text-emerald-900 font-medium" data-id="element-103">{item}</span>
                  </li>)}
              </ul>
            </div>

            {/* NO Column */}
            <div className="bg-red-50 rounded-2xl p-8 border border-red-100" data-id="element-104">
              <div className="flex items-center gap-3 mb-6" data-id="element-105">
                <div className="bg-red-400 text-white p-2 rounded-full" data-id="element-106">
                  <X className="w-6 h-6" data-id="element-107" />
                </div>
                <h3 className="text-xl font-bold text-red-900" data-id="element-108">
                  NO es para vos
                </h3>
              </div>
              <ul className="space-y-4" data-id="element-109">
                {['Si esperás resultados sin hacer ningún cambio', 'Si buscás prohibiciones totales y listas rígidas', 'Si necesitás reemplazar un tratamiento médico activo', 'Si no estás lista para comprometerte 28 días'].map((item, idx) => <li key={idx} className="flex items-start gap-3" data-id="element-110">
                    <X className="w-5 h-5 text-red-500 mt-0.5 flex-shrink-0" data-id="element-111" />
                    <span className="text-red-900 font-medium" data-id="element-112">{item}</span>
                  </li>)}
              </ul>
            </div>
          </div>

          <div className="text-center" data-id="element-113">
            <a href="https://www.elplacerquenutre.com//cart/44835922083942:1" onClick={e => trackAddToCart(e)} data-id="element-114">
              <Button size="xl" withArrow data-id="element-115">
                QUIERO EMPEZAR EL RETO AHORA
              </Button>
            </a>
            <div className="mt-4" data-id="element-116">
              <p className="text-xl md:text-2xl font-bold text-gray-900" data-id="element-117">
                $14,997 con el 50% desc
              </p>
              <p className="text-sm font-medium text-gray-500" data-id="element-118">
                Pago único — sin suscripciones
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}